import React from 'react';
import { IAssistantMessage } from '../../types';

const BOLD_TERMS = ['external colour', 'internal colour'];

function highlightText(text: string): React.ReactNode {
  if (!text) return text;
  const pattern = new RegExp(`(${BOLD_TERMS.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
  const parts = text.split(pattern);
  if (parts.length === 1) return text;
  return parts.map((part, i) =>
    BOLD_TERMS.some(t => t.toLowerCase() === part.toLowerCase())
      ? <strong key={i}>{part}</strong>
      : part
  );
}

interface ChatMessageProps {
  message: IAssistantMessage;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isBot = message.type === "assistant" || message.type === "price-surge";

  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'} mb-4 items-start`}>
      {isBot && (
        <div className="flex-shrink-0 w-[39px] h-[39px] rounded-full bg-primary-500 flex items-center justify-center text-white mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 8V4H8" />
            <rect width="16" height="12" x="4" y="8" rx="2" />
            <path d="M2 14h2" />
            <path d="M20 14h2" />
            <path d="M15 13v2" />
            <path d="M9 13v2" />
          </svg>
        </div>
      )}

      <div
        className={`px-5 py-3 ${
          isBot
          ? 'bg-[#F3F4F6] text-text-primary rounded-r-xl rounded-bl-xl rounded-tl-md max-w-[85%]'
          : 'bg-primary-500 text-white px-6 py-3 rounded-l-xl rounded-tr-md rounded-br-xl '
        }`}
      >
        <p className="text-sm md:text-[15px] leading-5 md:leading-6 whitespace-pre-wrap">{highlightText(message.message ?? '')}</p>
        {isBot && message.question?.helperText && (
          <p className="text-xs text-neutral-500 italic mt-1 whitespace-pre-wrap">{message.question.helperText}</p>
        )}
      </div>


      {!isBot && (
        <div className="flex-shrink-0 w-[39px] h-[39px] rounded-full bg-primary-500 flex items-center justify-center text-white ml-2 overflow-hidden">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="5" />
            <path d="M20 21a8 8 0 0 0-16 0" />
          </svg>
        </div>
      )}
    </div>
  );
};
